import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as s } from "tslib";
import { LitElement as i, html as a } from "lit";
import { stylesBase as r, styles1177 as n, styles1177pro as o, stylesIneraAdmin as d, stylesIneraAdminLegacy as l } from "./header-avatar-styles.js";
import c from "../../styles/global-styles.js";
import { property as h, state as p } from "lit/decorators.js";
var u, m, v, w, x, g;
class y extends i {
  constructor() {
    super(...arguments), u.set(this, ""), m.set(this, ""), v.set(this, ""), w.set(this, void 0), x.set(this, !1), g.set(this, !1), this.detectClickOutside = t => {
      !this.contains(t.target) && this.expanded && this.tooggleExpand();
    };
  }
  get username() {
    return e(this, u, "f");
  }
  set username(t) {
    s(this, u, t, "f");
  }
  get maxwidth() {
    return e(this, m, "f");
  }
  set maxwidth(t) {
    s(this, m, t, "f");
  }
  get unit() {
    return e(this, v, "f");
  }
  set unit(t) {
    s(this, v, t, "f");
  }
  get type() {
    return e(this, w, "f");
  }
  set type(t) {
    s(this, w, t, "f");
  }
  get expanded() {
    return e(this, x, "f");
  }
  set expanded(t) {
    s(this, x, t, "f");
  }
  get unresponsive() {
    return e(this, g, "f");
  }
  set unresponsive(t) {
    s(this, g, t, "f");
  }
  tooggleExpand() {
    let t;
    this.expanded = !this.expanded, t = this.expanded ? new CustomEvent("expanded") : new CustomEvent("closed"), this.dispatchEvent(t);
  }
  firstUpdated(t) {
    super.firstUpdated(t), document.addEventListener("click", this.detectClickOutside);
    const e = this.closest("ids-header");
    this.setAttribute("type", e.getAttribute("type")), null !== e.getAttribute("unresponsive") && (this.unresponsive = !0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.detectClickOutside);
  }
  renderAvatarBox() {
    switch (this.type) {
      case "1177":
      case "inera":
      case "inera-legacy":
        return a`<ids-row class="avatar-box">${this.renderIcon()}<ids-col class="avatar-text-col" alignself="center"><div style="${this.maxwidth ? `max-width: ${this.maxwidth}` : ""}" class="avatar-username">${this.username}</div><ids-row class="hide-on-mobile"><ids-col cols="auto" align="start" class="avatar-link avatar-link-divider"><slot name="avatar-left"></slot></ids-col><ids-col cols="auto" class="avatar-link"><slot name="avatar-right"></slot></ids-col></ids-row></ids-col></ids-row>`;
      case "1177-pro":
      case "inera-admin":
      case "inera-admin-legacy":
        return a`<ids-row class="avatar-box"><button aria-expanded="${this.expanded}" @click="${this.tooggleExpand}" class="btn-no-styles">${this.renderIcon()}<ids-col alignself="center"><ids-row align="center"><ids-col style="${this.maxwidth ? `max-width: ${this.maxwidth}` : ""}" class="username">${this.username}</ids-col><ids-col cols="auto" class="chevron"><ids-icon-chevron-bold class="ids-icon ${this.expanded ? "expanded" : ""}" color="var(--header-avatar-chevron-icon)" height="13" width="13"></ids-icon-chevron-bold></ids-col></ids-row><ids-row align="start" class="hide-on-mobile"><ids-col style="${this.maxwidth ? `max-width: ${this.maxwidth}` : ""}" class="unit">${this.unit}</ids-col></ids-row></ids-col></button> ${this.renderDropdown()}</ids-row>`;
    }
  }
  renderIcon() {
    return "inera-admin-legacy" === this.type || "inera-admin" === this.type ? a`` : "1177-pro" === this.type ? a`<ids-col class="avatar-icon" alignself="center" cols="auto"><ids-icon-user width="100%" height="100%" colorpreset="1"></ids-icon-user></ids-col>` : a`<ids-col class="avatar-icon" alignself="center" cols="auto"><ids-icon-user width="100%" height="100%" colorpreset="2"></ids-icon-user></ids-col>`;
  }
  renderDropdown() {
    return this.expanded ? a`<div class="dropdown"><slot name="dropdown"></slot></div>` : a``;
  }
  render() {
    return this.renderAvatarBox();
  }
}
u = new WeakMap(), m = new WeakMap(), v = new WeakMap(), w = new WeakMap(), x = new WeakMap(), g = new WeakMap(), y.styles = [c, r, n, o, d, l], t([h({
  type: String
})], y.prototype, "username", null), t([h({
  type: String
})], y.prototype, "maxwidth", null), t([h({
  type: String
})], y.prototype, "unit", null), t([h({
  type: String,
  reflect: !0
})], y.prototype, "type", null), t([p()], y.prototype, "expanded", null), t([h({
  type: Boolean,
  reflect: !0
})], y.prototype, "unresponsive", null);
export { y as IDSHeaderAvatar };